/* eslint-disable react/no-string-refs */
import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import ToastModal from "views/components/ToastModal";
import { IconButton } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

const styles = {
  fileUpload: {
    display: "flex",
  },
};

class FileUploadDocument extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      imagePreviewUrl: this.props.avatar || "",
      previewUrl: this.props.avatar || "",
      toast: false,
      toastMessageType: "",
      toastMessage: "",
    };
    this.fileInputRef = React.createRef();
  }

  handleImageChange = (e) => {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];
    if (!file) {
      return;
    }
    reader.onloadend = () => {
      if (file.size > 5000000) {
        this.toastUpdate("Error", "File size exceeds 5MB limit.", true);
      } else if (
        this.props.supportedMimeType &&
        this.props.supportedMimeType.indexOf(file.type) === -1
      ) {
        this.toastUpdate(
          "Error",
          `Unsupported file type. Allowed: ${this.props.supportedMimeType.join(
            ", "
          )}`,
          true
        );
      } else {
        this.setState(
          {
            file: file,
            imagePreviewUrl: file.name,
            previewUrl: reader.result,
          },
          () => this.props.sendFile(file)
        );
      }
    };
    reader.readAsDataURL(file);
  };

  handleClick = () => {
    this.fileInputRef.current.click();
  };

  handleRemove = () => {
    this.setState({
      file: null,
      imagePreviewUrl: this.props.avatar || "",
      previewUrl: this.props.avatar || "",
    });
    this.fileInputRef.current.value = null;
    if (this.props.removeFile) {
      this.props.removeFile();
    }
  };

  toastUpdate = (type, message, showToast) => {
    this.setState({
      toast: showToast,
      toastMessage: message,
      toastMessageType: type,
    });
  };

  render() {
    const {
      addButtonProps,
      changeButtonProps,
      removeButtonProps,
      name,
      removeButton,
      noPreview,
      buttonClass,
      localClasses,
      previewImage,
      completed,
    } = this.props;
    const previewSrc = previewImage || this.state.previewUrl;
    const isPdf =
      previewSrc?.toLowerCase().includes(".pdf") ||
      this.state.file?.type === "application/pdf";
    return (
      <>
        <div
          onClick={!removeButton ? this.handleClick : undefined}
          role="button"
          style={{
            width: "87%",
            minHeight: 270,
            border: "2px dashed #BFE8D6",
            borderRadius: 18,
            background: "#FBFFFC",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            transition: "all .3s ease",
            padding: 20,
            position: "relative",
          }}
        >
          <input
            type="file"
            accept={this.props.supportedMimeType?.join(",")}
            onChange={this.handleImageChange}
            ref={this.fileInputRef}
            style={{
              display: "none",
            }}
          />

          {this.state.file === null && !previewImage ? (
            <>
              <CloudUploadIcon
                style={{
                  fontSize: 65,
                  color: "#1CB167",
                  marginBottom: 15,
                }}
              />

              <div
                style={{
                  fontSize: 18,
                  fontWeight: 700,
                  color: "#333",
                  marginBottom: 8,
                }}
              >
                Drag & Drop Statement
              </div>

              <div
                style={{
                  color: "#777",
                  fontSize: 14,
                  marginBottom: 15,
                }}
              >
                or click to browse your computer
              </div>

              <div
                style={{
                  background: "#1CB167",
                  color: "#fff",
                  padding: "10px 20px",
                  borderRadius: 8,
                  fontWeight: 600,
                  fontSize: 14,
                }}
              >
                Choose File
              </div>

              <div
                style={{
                  marginTop: 18,
                  color: "#9A9A9A",
                  fontSize: 13,
                }}
              >
                PDF
              </div>
            </>
          ) : (
            <>
              {isPdf ? (
                <div
                  style={{
                    width: "87%",
                    background: "#F7FFF9",
                    border: "1px solid #D7F2E2",
                    borderRadius: 14,
                    padding: 20,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      fontSize: 55,
                    }}
                  >
                    📄
                  </div>

                  <div
                    style={{
                      fontWeight: 700,
                      marginTop: 12,
                      color: "#333",
                    }}
                  >
                    PDF Uploaded
                  </div>

                  <div
                    style={{
                      color: "#777",
                      fontSize: 13,
                      marginTop: 5,
                      maxWidth: 220,
                      textAlign: "center",
                      wordBreak: "break-word",
                    }}
                  >
                    {this.state.file?.name || "Statement.pdf"}
                  </div>

                  <a
                    href={previewSrc}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      marginTop: 18,
                      textDecoration: "none",
                      color: "#1CB167",
                      fontWeight: 600,
                    }}
                  >
                    Preview PDF
                  </a>
                </div>
              ) : (
                <img
                  src={previewSrc}
                  alt="preview"
                  style={{
                    width: "87%",
                    height: 220,
                    borderRadius: 14,
                    objectFit: "cover",
                  }}
                />
              )}
            </>
          )}
        </div>
        {(this.state.file !== null || previewImage) && !completed && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 16,
              marginTop: 18,
            }}
          >
            {!name && (
              <IconButton
                style={{
                  background: "#EEF9F3",
                  color: "#1CB167",
                  width: 42,
                  height: 42,
                }}
                onClick={this.handleClick}
              >
                <EditIcon />
              </IconButton>
            )}
            {!removeButton && (
              <IconButton
                style={{
                  background: "#FFF3F3",
                  color: "#0029ff",
                  width: 42,
                  height: 42,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleRemove();
                }}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </div>
        )}

        {this.state.toast && (
          <ToastModal
            toastMessage={this.state.toastMessage}
            toastMessageType={this.state.toastMessageType}
            toastUpdate={this.toastUpdate}
          />
        )}
      </>
    );
  }
}

FileUploadDocument.propTypes = {
  avatar: PropTypes.string,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
  supportedMimeType: PropTypes.array,
  sendFile: PropTypes.func,
  removeFile: PropTypes.func,
  noPreview: PropTypes.bool,
  name: PropTypes.string,
  removeButton: PropTypes.bool,
  buttonClass: PropTypes.string,
  localClasses: PropTypes.object,
};

export default withStyles(styles)(FileUploadDocument);
